module.exports = __webpack_public_path__ + "static/vida-80bd6817c904b1c03cf1a263a8dc4afd.png";